export default __webpack_public_path__ + "static/LadySpeedStick-cf50e536369c072f8018544228b5858e.png";